import React from "react";
import EventProgramHostedByFilters from "./EventProgramHostedByFilters";
import GlobalTimeNavigatorBar from "./GlobalTimeNavigatorBar";

/**
 * Event Dashboard metrics toolbar: Program, Hosted By, and time navigator
 * (same controls and semantics as Event Management).
 */
export default function EventDashboardMetricsFilters({
  programs,
  filterProgramId,
  onProgramChange,
  filterOrganizerId,
  onOrganizerChange,
  filterProgramMembers,
  timeNav,
}) {
  return (
    <div className="toolbar">
      <EventProgramHostedByFilters
        programs={programs}
        filterProgramId={filterProgramId}
        onProgramChange={onProgramChange}
        filterOrganizerId={filterOrganizerId}
        onOrganizerChange={onOrganizerChange}
        filterProgramMembers={filterProgramMembers}
      />
      <span className="toolbar-divider" />
      <GlobalTimeNavigatorBar
        variant="inline"
        title={timeNav.title}
        view={timeNav.view}
        onViewChange={timeNav.setView}
        onToday={timeNav.goToday}
        onPrev={timeNav.movePrev}
        onNext={timeNav.moveNext}
      />
    </div>
  );
}
